import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://50b80d6074a44e008f9651072271dc26@o385035.ingest.sentry.io/4505205427535872",
  sampleRate: 0.7,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === "production",
});
